import { render, staticRenderFns } from "./sharemanagement.vue?vue&type=template&id=99f76ff2&scoped=true&"
import script from "./sharemanagement.vue?vue&type=script&lang=js&"
export * from "./sharemanagement.vue?vue&type=script&lang=js&"
import style0 from "./sharemanagement.vue?vue&type=style&index=0&id=99f76ff2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99f76ff2",
  null
  
)

export default component.exports